var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheck, faExclamationCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FA_TIMES } from '../../../const/iconProps';
import { Container, IconWrapper, LeftBar, ToastBody, ToastCloseButton, ToastCloseIcon } from './subcomponents';
const generateIconFromType = (type) => {
    switch (type) {
        case 'error':
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle, size: "1x" });
        case 'success':
            return _jsx(FontAwesomeIcon, { icon: faCheck, size: "1x" });
        default:
            return _jsx(FontAwesomeIcon, { icon: faExclamationCircle, size: "1x" });
    }
};
const Toast = (_a) => {
    var { children, className, closeHandler, type = 'info', hasIcon = true, hasClose = true, hasShadow = true, closeButtonAriaLabel = 'Dismiss Toast' } = _a, props = __rest(_a, ["children", "className", "closeHandler", "type", "hasIcon", "hasClose", "hasShadow", "closeButtonAriaLabel"]);
    const icon = generateIconFromType(type);
    return (_jsxs(Container, Object.assign({ className: className, type: type, hasShadow: hasShadow }, props, { children: [_jsx(LeftBar, { type: type }), hasIcon && (_jsx(IconWrapper, Object.assign({ type: type, title: type }, { children: icon }))), _jsx(ToastBody, Object.assign({ type: type }, { children: children })), hasClose && closeHandler && (_jsx(ToastCloseButton, Object.assign({ buttonType: "text", ariaLabel: closeButtonAriaLabel, onClick: closeHandler }, { children: _jsx(ToastCloseIcon, { icon: FA_TIMES, size: "sm" }) })))] })));
};
export default Toast;
//# sourceMappingURL=Toast.js.map